import React from "react";
import NotificationContainer from "../notifications/NotificationContainer";
import { Box } from "@mui/material";

class HeaderLinks extends React.PureComponent {
  render() {
    return (
      <Box>
        <NotificationContainer />
      </Box>
    );
  }
}

export default HeaderLinks;
